// @flow

import React from 'react';
import { I18n } from 'react-redux-i18n';
import IconButton from '../../../../../components/IconButton';
import storesApi from '../../../../../network/api/storesApi';
import { download } from '../../../../../utils/utils';
import type { CoqueRetailer, Store } from '../../../../../types/apolloType';
import { notifyApolloError } from '../../../../../network/notification';

type State = {
  isGoodwillLoading: boolean,
}

type Props = {
  dispatch: () => void,
  shoppingCenter: ShoppingCenter,
  currentRetailer: CoqueRetailer,
  oldRetailer: Store,
  buttonName: React.Fragment,
}

class GoodwillButtonBestRetailer extends React.PureComponent<Props> {
  state: State = {
    isGoodwillLoading: false,
  }

  render() {
    return (
      <div className="btn-apollo-container">
        <IconButton
          icon="fal fa-file-download"
          className={`ripple-button ${this.state.isGoodwillLoading ? 'disabled' : ''} apollo-button-contained goodwill-download-button`}
          isLoading={this.state.isGoodwillLoading}
          onClick={() => {
            this.setState({ isGoodwillLoading: true });
            const { glaExclSst } = this.props.currentRetailer;
            storesApi.generateGoodwillFromBestRetailer(
              this.props.shoppingCenter.id,
              this.props.currentRetailer.codeStoreCoque,
              this.props.oldRetailer.codstr,
              this.props.currentRetailer.codeRetailerProposition,
              this.props.currentRetailer.retailerName,
              this.props.currentRetailer.bl3Name,
              this.props.currentRetailer.glaExclSst,
              // projectedMgr, projectedSales, trv are divided by glaExclSst
              this.props.currentRetailer.projectedMgr.average * glaExclSst,
              this.props.currentRetailer.projectedSales.average * glaExclSst,
              this.props.currentRetailer.trv.average * glaExclSst,
            ).then(excel => excel.blob())
              .then((responseBlob) => {
                download(
                  responseBlob,
                  I18n.t(
                    'SIDE_MENU.goodwill_report_filename',
                    {
                      retailerName: this.props.currentRetailer.retailerName,
                      shoppingCenter: this.props.shoppingCenter.name,
                    },
                  ),
                );
              }).catch(e => this.props.dispatch(notifyApolloError(e)))
              .finally(() => this.setState({ isGoodwillLoading: false }));
            }
          }
        >
          {this.props.buttonName}
        </IconButton>
      </div>
    );
  }
}

export default GoodwillButtonBestRetailer;
